import React from 'react';

import IconType from '../../../types/Icon';

const MarkIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M20.293 5.29688L9 16.5898L4.70703 12.2969L3.29297 13.7109L9 19.418L21.707 6.71094L20.293 5.29688Z"
				fill={color}
			/>
		</svg>
	);
};

export default MarkIcon;
